import { useCallback } from 'react';
// @ts-expect-error untyped dependency
import { fetchDashboard } from '../actions/DashboardActions';
export const useFetchDashboardOnOpen = ({
  dashboards,
  dashboardId
}) => {
  return useCallback(({
    target: {
      value: isOpen
    }
  }) => {
    if (isOpen && !dashboards.getIn(['dashboardFetched', dashboardId])) {
      fetchDashboard(dashboardId);
    }
  }, [dashboardId, dashboards]);
};